<template>
    <DModal
        :show="showModal"
        :title="__('orders.check.attachments_tab.create')"
        is-confirm
        :is-awaiting-validation="true"
        @confirm="confirm"
        @close="$emit('close-modal')"
    >
        <DCard padding>
            <DFormRow
                v-if="!props.file.id"
                :label="__('orders.check.attachments_tab.file')"
                is-required
                :error="errors.file"
                :hint="form.file ? form.file.name : ''"
            >
                <DFileInput
                    id="file"
                    :custom="true"
                    :multiple="false"
                    :is-valid="isFormFieldValid('file')"
                    @change="addFile"
                />
            </DFormRow>
            <DFormRow
                :label="__('orders.check.attachments_tab.description')"
                :error="errors.description"
            >
                <DFormTextarea
                    id="description"
                    v-model="form.description"
                    rows="5"
                    :is-valid="isFormFieldValid('description')"
                    maxlength="255"
                />
            </DFormRow>
        </DCard>
        <template
            v-if="errors[`error`]"
            #actions
        >
            <DAlert
                :color="'danger'"
                class="m-0 p-2"
            >
                {{ errors[`error`] }}
            </DAlert>
        </template>
    </DModal>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { ref } from 'vue'
import { __ } from '~@/Composables/translation'
import { route } from '~@/Composables/route'

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    order: {
        type: Object,
        default: () => { return {} }
    },
    file: {
        type: Object,
        default: () => { return {} }
    }
})

const emit = defineEmits(['close-modal', 'confirm-modal'])

const errors = ref({})

const form = useForm({
    id: props.file.id ?? null,
    file: props.file.file ?? null,
    description: props.file.description ?? null
})

function confirm () {
    if (form.id === null) {
        form.post(route('orders.psa.upload-file', { order: props.order.orderData.id }),
            {
                onSuccess: () => {
                    emit('close-modal')
                },
                onError: (error) => {
                    if (error) {
                        errors.value = error
                    }
                }
            }
        )
    } else {
        form.put(route('orders.psa.edit-file', { order: props.order.orderData.id, customer_file: props.file }),
            {
                onSuccess: () => {
                    emit('close-modal')
                },
                onError: (error) => {
                    if (error) {
                        errors.value = error
                    }
                }
            })
    }
}

function addFile (fileList) {
    form.file = fileList[0]
}

</script>

<style scoped lang="scss">
.error-msg {
    margin: 3px 0 0 0;
    font-size: 12px;
    color: var(--colorDanger);
}
</style>
